import { BigNumber } from '@ethersproject/bignumber'
import { parseUnits } from '@ethersproject/units'
import { sqrt } from '../utils'

export class Fixed18 {
  static ONE = new Fixed18(BigNumber.from(10).pow(18))
  static ZERO = new Fixed18(BigNumber.from(0))

  constructor(readonly value: BigNumber) {}

  static from(value: number | string, units = 18) {
    return new Fixed18(parseUnits(value.toString(), units))
  }

  add(other: Fixed18) {
    return new Fixed18(this.value.add(other.value))
  }

  sub(other: Fixed18) {
    return new Fixed18(this.value.sub(other.value))
  }

  mul(other: Fixed18) {
    return new Fixed18(this.value.mul(other.value).div(Fixed18.ONE.value))
  }

  div(other: Fixed18) {
    return new Fixed18(this.value.mul(Fixed18.ONE.value).div(other.value))
  }

  sqrt() {
    if (this.value.lt(0)) {
      throw new Error('Cannot compute square root of a negative number')
    }
    return new Fixed18(sqrt(this.value.mul(Fixed18.ONE.value)))
  }

  lt(other: Fixed18) {
    return this.value.lt(other.value)
  }

  lte(other: Fixed18) {
    return this.value.lte(other.value)
  }

  gt(other: Fixed18) {
    return this.value.gt(other.value)
  }

  gte(other: Fixed18) {
    return this.value.gte(other.value)
  }
}
